import { DialogButton } from "@constellation-academy/framework-react-components";
import React from "react";
import { useMutation } from "react-relay";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { type transferLicenseButton_TransferLicensesMutation } from "@relay/transferLicenseButton_TransferLicensesMutation.graphql";
import { TRANSFER_LICENSES_MUTATION } from "./transfer-license-button.graphql";
import { type TransferLicenseButtonProps } from "./transfer-license-button.types";
import { TransferLicenseForm } from "../transfer-license-form/transfer-license-form.component";

export const TransferLicenseButton = ({
	selectedIds,
	connectionId,
	currentAccountId,
	currentAccountName,
	onTransferComplete,
}: TransferLicenseButtonProps) => {
	const { t } = useTranslation("common");
	const [transferLicenses, isTransferring] =
		useMutation<transferLicenseButton_TransferLicensesMutation>(TRANSFER_LICENSES_MUTATION);

	return (
		<DialogButton
			buttonContent={{ label: t("licenses.transferButton") }}
			title={t("licenses.transferTitle")}
			disabled={isTransferring || selectedIds.length === 0}
		>
			{(hide) => {
				const handleOnSubmit = (targetAccount: { id: string; name: string }) => {
					if (selectedIds.length > 0) {
						transferLicenses({
							variables: {
								input: {
									licenseIds: selectedIds,
									targetAccountId: targetAccount.id,
								},
								connections: [connectionId],
							},
							onCompleted: () => {
								hide();
								if (
									onTransferComplete &&
									targetAccount.name === currentAccountName
								) {
									onTransferComplete(targetAccount.name);
								}
							},
							onError: (error) => {
								// eslint-disable-next-line no-console
								console.error("Error transferring licenses:", error);
								const errorMessage =
									error instanceof Error
										? error.message
										: typeof error === "string"
										? error
										: t("licenses.unknownError");
								toast.error(t("licenses.transferError", { message: errorMessage }));
							},
						});
					}
				};

				return (
					<TransferLicenseForm
						onSubmit={handleOnSubmit}
						onCancel={hide}
						isSubmitting={isTransferring}
						currentAccountId={currentAccountId}
					/>
				);
			}}
		</DialogButton>
	);
};
